import { useToastStore } from './toastStore'

export function useToast() {
  const pushToQueue = useToastStore((state) => state.pushToQueue)
  return pushToQueue
}
